import { AutoComplete } from '@components/AutoComplete/AutoComplete';
import styled from '@emotion/styled';
import { FilterAltOutlined, Search } from '@mui/icons-material';
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  TextField,
  useTheme,
} from '@mui/material';
import { MouseEvent, useState } from 'react';

type ComplexPageHeaderProps = {
  buttonText: string;
  onClick: () => void;
  searchPlaceholder?: string;
  searchValue: string;
  setSearchValue: (value: string) => void;
  options?: { label: string; value: string }[];
  onChange?: (value: string) => void;
  placeholder?: string;
  actionButtonText?: string;
  actionButtonOnClick?: () => void;
  value?: string;
};

export const ComplexPageHeader = ({
  buttonText,
  onClick,
  searchPlaceholder,
  searchValue,
  setSearchValue,
  options,
  onChange,
  placeholder,
  actionButtonText,
  actionButtonOnClick,
  value,
}: ComplexPageHeaderProps) => {
  const theme = useTheme();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Header>
      <NewElementButton variant="contained" onClick={onClick}>
        {buttonText}
      </NewElementButton>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          width: '100%',
          '@media (min-width: 768px)': {
            flexDirection: 'row',
          },
        }}
      >
        <TextField
          placeholder={searchPlaceholder || 'Search'}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <Search
                    sx={{
                      color: theme.palette.divider,
                    }}
                  />
                </InputAdornment>
              ),
            },
          }}
        />
        <IconButton
          sx={{
            border: `2px dashed ${theme.palette.divider} !important`,
            height: '36px',
            width: '36px',
          }}
          onClick={handleClick}
        >
          <FilterAltOutlined />
        </IconButton>
        <AutoComplete
          options={options || []}
          value={value}
          onChange={onChange || (() => {})}
          placeholder={placeholder}
          actionButtonText={actionButtonText}
          actionButtonOnClick={actionButtonOnClick}
          anchorEl={anchorEl}
          handleClose={handleClose}
        />
      </Box>
    </Header>
  );
};

const NewElementButton = styled(Button)`
  width: 100%;
  @media (min-width: 768px) {
    width: auto;
  }
`;

const Header = styled.header`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
  @media (min-width: 768px) {
    flex-direction: row;
  }
`;
